import { render, staticRenderFns } from "./CreateCustomField.vue?vue&type=template&id=4980082c&scoped=true"
import script from "./CreateCustomField.vue?vue&type=script&lang=js"
export * from "./CreateCustomField.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomField.vue?vue&type=style&index=0&id=4980082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980082c",
  null
  
)

export default component.exports